.notes {
	height: 85%;
}

.notes_modification {
	text-align: right;
	font-size: 9px;
}
